export const INIT_TRIGGER = 'INIT_TRIGGER';
export const INIT_API_REQUEST = 'INIT_API_REQUEST';
export const INIT_API_SUCCESS = 'INIT_API_SUCCESS';
export const INIT_API_FAILURE = 'INIT_API_FAILURE';
